import axios from "../axios/AxiosInstance";

const day = (value) => (value ? String(value).slice(0, 10) : "");
const status = (value) =>
  !value || /^a traiter$/i.test(value)
    ? "À traiter"
    : /trait/i.test(value)
      ? "Traitée"
      : value;

export const toAbsenceRow = (arret) => ({
  id: arret._id,
  candidateId: arret.candidate?._id || arret.candidate,
  name: arret.candidateName,
  type: arret.typeAbsence,
  comment: arret.comment || "",
  start: day(arret.startDate),
  end: day(arret.endDate),
  fileName: arret.name,
  status: status(arret.status),
  author: arret.createdByName || "",
  createdAt: arret.createdAt || "",
});

export async function listAbsences(signal) {
  const { data } = await axios.get("arret/freelance", { signal });
  return Array.isArray(data) ? data.map(toAbsenceRow) : [];
}

export async function createAbsence({ candidate, type, start, end, comment, file }) {
  const body = new FormData();
  body.append("file", file);
  body.append("candidateId", candidate._id);
  body.append("candidateName", [candidate.firstname, candidate.lastname].filter(Boolean).join(" "));
  body.append("typeAbsence", type);
  body.append("startDate", start);
  body.append("endDate", end);
  body.append("comment", comment.trim());
  const { data } = await axios.post("arret", body);
  return toAbsenceRow({ ...data, candidate: candidate._id });
}

export async function downloadAbsenceProof(row) {
  const { data } = await axios.get(`arret/freelance/${row.id}`);
  const mime = data.type === "pdf" ? "application/pdf" : `image/${data.type}`;
  const bytes = Uint8Array.from(atob(data.data), (char) => char.charCodeAt(0));
  const url = URL.createObjectURL(new Blob([bytes], { type: mime }));
  const link = document.createElement("a");
  link.href = url;
  link.download = data.name || row.fileName;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
